"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const icon_1 = __importDefault(require("../../components/icon/icon"));
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const schedulesList_1 = __importDefault(require("../../components/schedules/schedulesList"));
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const eventConstants_1 = require("../../constants/eventConstants");
const screenConstants_1 = require("../../constants/screenConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const SchedulesSlice_1 = require("./SchedulesSlice");
const scheduleSlice_1 = require("./scheduleSlice");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const constants_1 = require("../../constants/constants");
const filterTopUserEngagementSchedule_1 = __importDefault(require("../../components/filterPersistentSchedule/filterTopUserEngagementSchedule"));
const paginatedMessageComponent_1 = __importDefault(require("../../components/messageComponent/paginatedMessageComponent"));
const utils_1 = require("../../utils/utils");
const userCustomerInfo_1 = __importDefault(require("../../components/customerInfo/userCustomerInfo"));
const supportSlice_1 = require("../support/supportSlice");
const communicationBoxUtils_1 = require("../../components/communicationBox/communicationBoxUtils");
const queueCommunicationBox_1 = __importDefault(require("../../components/communicationBox/queueCommunicationBox"));
const TopUserEngagement = () => {
    const dispatch = useAppDispatch_1.default();
    const navigation = native_1.useNavigation();
    const { officer, schedules, loadingStatus, customer, callerInbound } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
        schedules: state.schedules.schedules,
        loadingStatus: state.schedules.loadingStatus,
        customer: state.support.customer,
        callerInbound: state.communication.callerInbound,
    }));
    const navigator = native_1.useNavigation();
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_2);
    const phoneNumber = communicationBoxUtils_1.parseInboundContact(callerInbound);
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const title = 'Top User Engagement Schedules';
    const [queryParams, setQueryParams] = react_1.useState({
        page: 1,
        ...(!officer.is_manager && { officer_id: String(officer.id) }),
    });
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(scheduleSlice_1.resetScheduleState());
        dispatch(SchedulesSlice_1.getTopUserEngagementSchedules(queryParams));
    }, []));
    react_1.useEffect(() => {
        const fetchCustomerData = async () => {
            // Do a basic phone number validation before making a request to get user details.
            if (communicationBoxUtils_1.validatePhoneNumber(phoneNumber)) {
                return;
            }
            // Dispatch the first action
            const customerDetails = await dispatch(supportSlice_1.getCustomerDetails({ phone_number: phoneNumber })).unwrap();
            if (customerDetails && customerDetails.user_uuid) {
                dispatch(SchedulesSlice_1.getUserSchedules({
                    page: 1,
                    externalId: customerDetails.user_uuid,
                }));
            }
        };
        fetchCustomerData();
    }, [callerInbound]);
    const getSchedulesPage = (page) => {
        const updateParams = { ...queryParams, page };
        setQueryParams(updateParams);
        dispatch(SchedulesSlice_1.resetSchedulesState());
        dispatch(SchedulesSlice_1.getTopUserEngagementSchedules({ page, ...(!officer.is_manager && { officerId: String(officer.id) }) }));
    };
    const getCustomerSchedulesPage = (page) => {
        dispatch(SchedulesSlice_1.resetSchedulesState());
        if (customer && customer.user_uuid) {
            dispatch(SchedulesSlice_1.getUserSchedules({
                page,
                externalId: customer.user_uuid,
            }));
        }
    };
    const navigateToSchedule = ({ scheduleId }) => {
        navigation.push(screenConstants_1.SCHEDULE_SCREEN, { schedule_id: scheduleId });
    };
    const openScheduleInNewTab = ({ scheduleId }) => {
        const url = `/schedule?schedule_id=${scheduleId}`;
        react_native_1.Linking.openURL(url);
    };
    const clearCustomerData = async () => {
        await dispatch(supportSlice_1.resetSupportState());
        dispatch(SchedulesSlice_1.getTopUserEngagementSchedules(queryParams));
    };
    let content = react_1.default.createElement(react_1.default.Fragment, null);
    if (loadingStatus === typesConstants_1.PENDING_STATUS) {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    else if (loadingStatus === typesConstants_1.SUCCEEDED_STATUS) {
        content = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow }, schedules.length === 0 ? (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
            react_1.default.createElement(paginatedMessageComponent_1.default, { message: "No top user engagement schedules at the moment.", color: colors_1.default.GREEN, icon: free_solid_svg_icons_1.faCheckCircle }))) : (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, styles_1.default.flexOne] },
            react_1.default.createElement(schedulesList_1.default, { schedules: schedules, onRowPress: navigateToSchedule, onPageChange: getSchedulesPage })))));
    }
    else {
        content = react_1.default.createElement(messageComponent_1.default, { message: "An error occurred.", color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle });
    }
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: containerStyle },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: title })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(pressable_1.default, { onPress: customer ? () => clearCustomerData() : () => navigator.navigate(screenConstants_1.DASHBOARD_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_HOME_BUTTON },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, `Back `)))))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionColumn },
                react_1.default.createElement(queueCommunicationBox_1.default, { collapsible: true }),
                customer ? (!utils_1.isObjectEmpty(customer) && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexTwo, styles_1.default.marginTopTen] },
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                        react_1.default.createElement(userCustomerInfo_1.default, { user: customer })),
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, styles_1.default.flexOne, { height: 470 }] },
                        react_1.default.createElement(react_native_paper_1.Title, { style: [
                                styles_1.default.textColorBlack,
                                styles_1.default.marginBottomTen,
                                styles_1.default.fontWeightBold,
                            ] }, `User Schedules `),
                        react_1.default.createElement(schedulesList_1.default, { schedules: schedules, onRowPress: openScheduleInNewTab, onPageChange: getCustomerSchedulesPage }))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(filterTopUserEngagementSchedule_1.default, { setQueryParams: setQueryParams, queryParams: queryParams }),
                    content))))));
};
exports.default = TopUserEngagement;
